import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import AbstractVCCalculatorBase from '../abstract-base-vc-calculator';
import isViewportEntryData from '../utils/is-viewport-entry-data';
var ABORTING_WINDOW_EVENT = ['wheel', 'scroll', 'keydown', 'resize'];
var REVISION_NO = 'fy25.03';
var CONSIDERED_ENTRY_TYPE = ['mutation:child-element', 'mutation:element', 'mutation:attribute', 'layout-shift', 'window:event'];
var VCCalculator_FY25_03 = /*#__PURE__*/function (_AbstractVCCalculator) {
  function VCCalculator_FY25_03() {
    _classCallCheck(this, VCCalculator_FY25_03);
    return _callSuper(this, VCCalculator_FY25_03, [REVISION_NO]);
  }
  _inherits(VCCalculator_FY25_03, _AbstractVCCalculator);
  return _createClass(VCCalculator_FY25_03, [{
    key: "isEntryIncluded",
    value: function isEntryIncluded(entry) {
      if (!CONSIDERED_ENTRY_TYPE.includes(entry.type)) {
        return false;
      }
      if (entry.type === 'mutation:attribute') {
        var entryData = entry.data;
        var attributeName = entryData.attributeName;
        if (!attributeName) {
          return false;
        }
        return true;
      }
      if (isViewportEntryData(entry.data) && !entry.data.visible) {
        return false;
      }
      return true;
    }
  }, {
    key: "isVCClean",
    value: function isVCClean(filteredEntries) {
      var hasAbortEvent = filteredEntries.some(function (entry) {
        if (entry.type === 'window:event') {
          var data = entry.data;
          if (ABORTING_WINDOW_EVENT.includes(data.eventType)) {
            return true;
          }
        }
        return false;
      });
      return !hasAbortEvent;
    }
  }]);
}(AbstractVCCalculatorBase);
export { VCCalculator_FY25_03 as default };